module.exports = __webpack_public_path__ + "static/favicon-5cde2da1315d20b847fbfc70c0f30f3f.ico";